import React from "react";
import "./style.sass";
import imgPlaceholder from "../assets/img-placeholder.png";

export const Thumb = (props) => {
  const { selected, index, onClick, activeIndex } = props;

  return (
    <div
      className={"embla-thumbs__slide".concat(
        selected ? " embla-thumbs__slide--selected" : ""
      )}
    >
      <button
        onClick={onClick}
        type="button"
        className={`embla-thumbs__slide__number ${
          selected && "embla-thumbs__slide--selected"
        } `}
      >
        <img
          className={activeIndex ? "embla-thumbs__slide--active" : ""}
          src={index.url || imgPlaceholder}
          alt={index.legend}
        />
      </button>
    </div>
  );
};
